import type { ContactsView } from '../types.js'
import { RevealableAddress } from './RevealableAddress.js'

/** How a worker can be reached, as staff and the admin see it: each channel with its described address and state. Nothing here is editable (plan D15). With `workerId`, a number or email has the eye that shows it whole. */
export function ContactsSummary({ contacts, workerId, empty = 'Only in the app so far: this worker has not turned on alerts anywhere.' }: { contacts: ContactsView; workerId?: string; empty?: string }) {
  if (contacts.channels.length === 0) {
    return <p className="text-xs text-ink-mid">{empty}</p>
  }
  return (
    <ul className="space-y-1 text-[11px]">
      {contacts.channels.map((contact) => (
        <li key={contact.contactId} className="flex flex-wrap items-baseline gap-x-2">
          <span className="font-bold text-ink">{contact.channelLabel}</span>
          {workerId ? <RevealableAddress workerId={workerId} contact={contact} className="text-ink-mid" /> : <span className="text-ink-mid">{contact.address}</span>}
          {contact.label && <span className="text-ink-mid">· {contact.label}</span>}
          <span className={contact.enabled && contact.verifiedAt ? 'text-green' : contact.awaitingAgreement ? 'text-gold' : 'text-ink-mid'}>· {contact.awaitingAgreement ? 'waiting for the worker to agree' : contact.optedOut ? `opted out ${new Date(contact.optedOut.at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : !contact.enabled ? 'switched off' : contact.verifiedAt ? 'on' : contact.lockedUntil ? 'held after wrong codes' : 'waiting for the code'}</span>
          {contact.failures > 0 && <span className="text-coral">· {contact.failures} failed in a row</span>}
        </li>
      ))}
    </ul>
  )
}
